import React, { Component } from 'react';
import PropTypes from 'prop-types';
import JsonapiClient from '@holidayextras/jsonapi-client';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { toast } from 'react-toastify';
import { CSVLink } from 'react-csv';

import { Segment, Button, Form, Header, Input, Divider, Icon, Message, Label, Radio, Grid } from 'semantic-ui-react';
import ReactQuill from 'react-quill';
import theme from 'react-quill/dist/quill.snow.css';
import _ from 'lodash';
import v from 'validator';
import moment from 'moment';
import axios from 'axios';
import { authService } from '../../utils/auth-service';
import InfluencerShortlistEditableCard from '../../components/influencer-shortlist-editable-card';
import ShortlistSummary from '../../components/shortlist-summary';
import CloneShortlistModal from '../../components/clone-shortlist';
import NewAddCampaignModal from '../../components/new-add-campaign-modal';

import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';

import createNewCampaign from '../../utils/create-new-campaign';

import { YoutubeIcon, FacebookIcon, TwitterIcon, InstagramIcon, TwitchIcon } from '../../components/dyzio-icons';


import ThemeSelector from '../../themes/theme-selector';

const currentTheme = ThemeSelector.theme();

const iconStyle = {
  height: '1rem',
  margin: '0 5px',
};

const MT5 = {
  marginTop: 5,
};

const MR15 = {
  marginRight: 15,
};

const cloneShortlistStyle = {
  cursor: 'pointer',
};

const TEAM_DYZIO_ID = 'f14d3931-0e6a-42e8-ad3c-ae2ff07e3d96';

class Shortlist extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      compactCards: false,
      shortlist: {
        name: 'loading...',
        notes: 'loading...',
      },
      addCampaignModalOpen: false,
      cloneModal: {
        visible: false,
        selected: null,
        options: [],
        isSearching: false,
        searched: false,
      },
      history: [],
      dataMap: {},
      status: 'CREATED',
      wrongShareValues: [],
      isShortlistApprovalDisabled: false,
      selectedPlatforms: {},
    };

    this.jsonClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    this.restClient = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 2000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });

    this.cloneClient = axios.create({
      baseURL: 'https://ag7nil8td4.execute-api.eu-west-1.amazonaws.com/production/importer/shortlist/clone',
      timeout: 2000,
      headers: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }

  componentDidMount = async () => {
    await this.loadShortlist();
    window.scrollTo(0, 0);
  }

  toggleAddCampaignModalState = () => {
    this.setState(prevState => ({
      addCampaignModalOpen: !prevState.addCampaignModalOpen,
    }));
  }

  loadShortlist = () => {
    const id = this.props.params.id;

    return this.jsonClient.get('shortlists', id,
      { include: ['influencers', 'organisation', 'influencerLinks.influencerDetails'] })
      .then(response => {
        const linksMap = _.map(response.influencerLinks, l =>
          ({ influencerId: l.influencer && l.influencer._base.id, linkId: l._base.id }));
        const listJson = response.toJSONTree();
        this.setState({
          saved: true,
          shortlist: listJson,
          list: listJson.influencers,
          links: listJson.influencerLinks,
          linksMap,
          initialName: listJson.name,
          loading: false,
          dataMap: listJson.dataMap || {},
          history: listJson.history || [],
          isShortlistApprovalDisabled: listJson.isShortlistApprovalDisabled || false,
          selectedPlatforms: listJson.selectedPlatforms ||
            {
              instagram: true,
              facebook: true,
              youtube: true,
              tiktok: true,
              twitch: true,
              twitter: true,
            },
        });
      }).catch(e => {
        console.log(e);
      });
  }

  handleNameChange = (e, { value }) => {
    const { shortlist } = this.state;
    shortlist.name = value;
    this.setState({
      shortlist,
    });
  }

  handleQuillChange = value => {
    const { shortlist } = this.state;
    shortlist.notes = value;
    this.setState({
      shortlist,
    });
  }

  toastMessage = message => (
    <div>
      <h3>
        <Icon name="save" color="pink" />
        {message}
      </h3>
    </div>
  );

  handleApprovalSave = () => {
    const { isShortlistApprovalDisabled } = this.state;
    const id = this.props.params.id;

    const patch = {
      data: {
        type: 'shortlists',
        attributes: {
          isShortlistApprovalDisabled: !isShortlistApprovalDisabled,
        },
      },
    };

    this.restClient.patch(`/shortlists/${id}`, patch)
      .then(() => {
        toast(this.toastMessage('Shortlist saved OK!'));
        this.setState({
          isShortlistApprovalDisabled: !isShortlistApprovalDisabled,
        });
      })
      .catch(e => {
        console.log(e);
      });
  }

  handlePlatformsSave = platform => {
    const { selectedPlatforms } = this.state;
    const id = this.props.params.id;

    console.log(selectedPlatforms);

    const newSelectedPlatforms = selectedPlatforms;
    newSelectedPlatforms[platform] = !newSelectedPlatforms[platform];

    console.log(newSelectedPlatforms);

    this.setState({
      selectedPlatforms: newSelectedPlatforms,
    });

    const patch = {
      data: {
        type: 'shortlists',
        attributes: {
          selectedPlatforms,
        },
      },
    };

    console.log(patch);

    this.restClient.patch(`/shortlists/${id}`, patch)
      .then(() => {
        toast(this.toastMessage('Shortlist saved OK!'));
      })
      .catch(e => {
        console.log(e);
      });
  }

  handleSave = () => {
    const { dataMap, history, status } = this.state;
    const { name, notes } = this.state.shortlist;
    const id = this.props.params.id;

    const patch = {
      data: {
        type: 'shortlists',
        attributes: {
          notes,
          name,
          dataMap,
          history,
          status,
        },
      },
    };

    this.restClient.patch(`/shortlists/${id}`, patch)
      .then(() => {
        toast(this.toastMessage('Shortlist saved OK!'));
      })
      .catch(e => {
        console.log(e);
      });
  }

  handleRemove = influencerId => {
    const id = this.props.params.id;
    const { influencers } = this.state.shortlist;

    const removedInfluencer = _.remove(influencers, { id: influencerId })[0];
    console.log(removedInfluencer);
    const influencersPatch = _.map(influencers, i => ({ type: 'influencer', id: i.id }));

    const patch = {
      data: {
        type: 'shortlists',
        attributes: {
          influencers: influencersPatch,
        },
      },
    };

    this.restClient.patch(`/shortlists/${id}`, patch)
      .then(() => {
        toast(this.toastMessage(`Removed ${removedInfluencer.name}!`));
        const sl = this.state.shortlist;
        sl.influencers = influencers;
        this.setState({
          shortlist: sl,
        });
      })
      .catch(e => {
        console.log(e);
      });
  }

  handleNoteChange = (id, e) => {
    const { dataMap } = this.state;
    const dataNode = dataMap[id] || {};
    dataNode.description = e;
    dataMap[id] = dataNode;
  }

  handleShare = () => {
    const { history, emailList } = this.state;
    const { user } = this.props;
    const shortlistId = this.props.params.id;

    const emails = _.split(emailList, ',');
    const trimmedEmails = _.map(emails, e => (_.trim(e)));
    const wrongShareValues = _.filter(trimmedEmails, x => !v.isEmail(x));

    if (wrongShareValues.length > 0) {
      this.setState({
        wrongShareValues,
      });
      return;
    }

    history.push(
      { message: `${user.name} shared the shortlist with ${emailList} on ${moment(new Date()).format('DD MMM YYYY')}` },
    );

    const share = this.jsonClient.create('shares');


    share.set('sharedWith', trimmedEmails);
    share.set('resourceType', 'SHORTLIST');
    share.set('resource', {
      type: 'shortlists',
      id: shortlistId,
    });

    share.set('sharedDate', new Date());
    share.set('sharedBy', user.name);

    share.sync()
      .then(r => {
        console.log(r);
        this.setState({
          history,
          emailList: '',
          status: 'SHARED',
          wrongShareValues: [],
        }, this.handleSave);
      })
      .catch(err => {
        console.log(err);
      });
  }

  handleChange = (e, { name, value }) => {
    this.setState({
      [name]: value,
    });
  }

  toggleCardView = () => {
    const { compactCards } = this.state;
    this.setState({
      compactCards: !compactCards,
    });
  }

  openCloneShortListModal = () => {
    const { cloneModal } = this.state;
    const updated = _.assign(cloneModal, { visible: true });
    this.setState({
      cloneModal: updated,
    });
  }

  closeCloneShortListModal = () => {
    const { cloneModal } = this.state;
    const updated = _.assign(cloneModal, {
      visible: false,
      selected: null,
    });
    this.setState({
      cloneModal: updated,
    });
  }

  handleCloneShortListModalSearch = _.debounce((event, data) => {
    const { value } = data;
    const { cloneModal } = this.state;

    if (!value) {
      const cloneModalUpdated = _.assign(cloneModal, { isSearching: false, searched: false });
      this.setState({ cloneModal: cloneModalUpdated });
      return;
    }

    const cloneModalUpdated = _.assign(cloneModal, { isSearching: true });

    this.setState({
      cloneModal: cloneModalUpdated,
    }, () => this.searchOrganisation(value));
  }, 1000);

  searchOrganisation = value => {
    const encodedValue = encodeURI(value);
    this.restClient.get(`/organisations?filter[name]=:${encodedValue}&filter[orgType]=REAL_AGENCY`).then(response => {
      const { data: { data } } = response;
      const options = _.map(data, organisation => ({
        title: organisation.attributes.name,
        id: organisation.id,
      }));
      const { cloneModal } = this.state;
      const updated = _.assign(cloneModal, {
        options,
        isSearching: false,
        searched: true,
      });
      this.setState({
        cloneModal: updated,
      });
    }).catch(error => {
      console.log(error);
    });
  }

  handleOptionsSelected = (event, data) => {
    const { result } = data;
    const { cloneModal } = this.state;
    const updated = _.assign(cloneModal, { selected: result });
    this.setState({
      cloneModal: updated,
    });
  }

  handleCloneButton = () => {
    const { cloneModal } = this.state;
    const recipientOrganisationId = cloneModal.selected.id;

    const shortlistId = this.props.params.id;

    const dto = {
      data: {
        shortlistId,
        recipientOrganisationId,
      },
    };

    this.cloneClient.post('/', dto)
      .then(response => {
        console.log(response);
        this.closeCloneShortListModal();
      });
  }

  onAddCampaignSubmit = values => {
    const {
      jsonAPIClient,
      userInfo,
    } = this.props;

    const shortlistId = this.props.params.id;
    _.assignIn(values, { shortlistId });

    return createNewCampaign({
      ...values,
      jsonAPIClient,
      userInfo,
    });
  };

  render() {
    const {
      list,
      shortlist,
      initialName,
      loading,
      history,
      dataMap,
      emailList,
      compactCards,
      wrongShareValues,
      cloneModal,
      links,
      linksMap,
      isShortlistApprovalDisabled,
      selectedPlatforms,
      addCampaignModalOpen,
    } = this.state;

    const { influencers } = shortlist;

    const id = this.props.params.id;
    const buttonStyles = {
      width: '150px',
    };
    const verticalAlignSuperStyle = {
      'vertical-align': 'super',
    };

    const basicData = list ? _.map(list, li => ({
      name: li.name,
      email: li.email,
      primarySocialHandle: li.primarySocialHandle,
      thumbnail: li.thumbnail,
      country: li.country,
      youtube: li.youtube,
      instagram: li.instagram,
      facebook: li.facebook,
      twitter: li.twitter,
      tiktok: li.tiktok,
      youtubeChannelTitle: li.youtubeChannelTitle,
      youtubeCount: li.youtubeCount,
      instagramCount: li.instagramCount,
      instagramEngagementRate: _.get(li, 'instagramEngagementRate'),
      facebookCount: li.facebookCount,
      twitterCount: li.twitterCount,
      tiktokCount: li.tiktokCount,
      tiktokEngagementRate: _.get(li, 'tiktokProfileData.engagementData.engagementRate'),
    })) : [];

    const filename = `${_.kebabCase(initialName)}.csv`;

    const { hostname } = window.location;
    const isVoxogram = (hostname === 'app.voxogram.com');

    const shareableLink = `${currentTheme.shareSite}/shortlists/${id}`;
    const shareableLinkTable = `${currentTheme.shareSite}/shortlists2/${id}`;
    const shareableLinkInstagramTiktok = `${currentTheme.shareSite}/shortlists3/${id}`;

    const { user } = this.props;
    const isDyzioTeam = user && user.organisation.id === TEAM_DYZIO_ID;

    const influencerCount = _.size(influencers);
    const totalInstagram = _.sumBy(influencers, 'instagramCount');
    const totalYoutube = _.sumBy(influencers, 'youtubeCount');
    const totalFacebook = _.sumBy(influencers, 'facebookCount');
    const totalTwitter = _.sumBy(influencers, 'twitterCount');
    const totalTwitch = _.sumBy(influencers, 'twitchCount');
    const totalTiktok = _.sumBy(influencers, 'tiktokCount');

    return (

      <div className="page">

        <div style={{ height: 140, backgroundColor: '#FFF', borderBottom: '1px solid #EEE' }}>
          <div className="page-hero">

            <Header as="h2" style={{ paddingTop: 40 }}>
              <div style={{ width: 500, float: 'right', textAlign: 'right', padding: 10 }}>
                { isDyzioTeam && <Label
                  basic
                  size="large"
                  color="pink"
                  onClick={this.openCloneShortListModal}
                  style={cloneShortlistStyle}
                >
                  <Icon name="clone outline" /><a>Clone Shortlist</a>
                </Label>
                }

                <Label
                  basic
                  size="large"
                  color="pink"
                  onClick={this.toggleAddCampaignModalState}
                  style={cloneShortlistStyle}
                >
                  <Icon name="lightning" /><a>Create Campaign</a>
                </Label>

                <Label basic size="large" color="pink">
                  <Icon name="file excel outline" />
                  <CSVLink data={basicData} filename={filename}>Download Shortlist</CSVLink>
                </Label>
              </div>
              {initialName}
              <Header.Subheader>
              Created by {shortlist.createdBy} on {moment(shortlist.createdDate).format('DD MMM YYYY')}
              </Header.Subheader>
            </Header>
          </div>
        </div>

        <div className="page-content">

          <Segment>
            <Header as="h2">
            Shortlist name
            </Header>
            <p className="small light"><em>(visible to client)</em></p>
            <Input value={shortlist.name} fluid onChange={this.handleNameChange} />

            <br />

            <Header as="h2">
            Shortlist notes
            </Header>
            <p className="small light"><em>(visible to client)</em></p>

            <ReactQuill
              value={shortlist.notes}
              onChange={this.handleQuillChange}
            />

            <br />
            <div style={{ width: '100%' }}>
              <span>
                <Radio
                  toggle checked={!isShortlistApprovalDisabled}
                  onChange={() => {
                    this.handleApprovalSave();
                  }
                  }
                /> <span style={verticalAlignSuperStyle}> Enable Shortlist Approval</span>
              </span>
              <span
                style={{ float: 'right' }}
              >
                <Button content="cancel" icon="cancel" style={buttonStyles} />
                <Button content="save" icon="save" onClick={this.handleSave} style={buttonStyles} />
              </span>
            </div>
            <div style={{ width: '100%', 'margin-top': '15px' }}>
              <Header as="h2">
              Channels
              </Header>
              <p className="small light"><em>choose which social networks to display in the shortlist</em></p>
              <Grid style={MT5}>
                <Grid.Row>
                  <Grid.Column style={MR15}>
                    <InstagramIcon size="large" style={iconStyle} />
                    <Radio
                      toggle checked={selectedPlatforms.instagram}
                      onChange={() => {
                        this.handlePlatformsSave('instagram');
                      }
                      }
                    />
                  </Grid.Column>
                  <Grid.Column style={MR15}>
                    <FacebookIcon size="large" style={iconStyle} />
                    <Radio
                      toggle checked={selectedPlatforms.facebook}
                      onChange={() => {
                        this.handlePlatformsSave('facebook');
                      }
                      }
                    />
                  </Grid.Column>
                  <Grid.Column style={MR15}>
                    <YoutubeIcon size="large" style={iconStyle} />
                    <Radio
                      toggle checked={selectedPlatforms.youtube}
                      onChange={() => {
                        this.handlePlatformsSave('youtube');
                      }
                      }
                    />
                  </Grid.Column>
                  <Grid.Column style={MR15}>
                    <img style={iconStyle} src={'/icons/tik-tok.svg'} alt="Tiktok" />
                    <Radio
                      toggle checked={selectedPlatforms.tiktok}
                      onChange={() => {
                        this.handlePlatformsSave('tiktok');
                      }
                      }
                    />
                  </Grid.Column>
                  <Grid.Column style={MR15}>
                    <TwitchIcon size="large" style={iconStyle} />
                    <Radio
                      toggle checked={selectedPlatforms.twitch}
                      onChange={() => {
                        this.handlePlatformsSave('twitch');
                      }
                      }
                    />
                  </Grid.Column>
                  <Grid.Column style={MR15}>
                    <TwitterIcon size="large" style={iconStyle} />
                    <Radio
                      toggle checked={selectedPlatforms.twitter}
                      onChange={() => {
                        this.handlePlatformsSave('twitter');
                      }
                      }
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </Segment>

          <Segment>
            <Header as="h2">
            Sharing
            </Header>

            <Message icon info>
              <Icon name="share alternate" />
              <Message.Content>
                <Message.Header>Shareable link (Original)</Message.Header>
                {shareableLink}&nbsp;-&nbsp; <a href={shareableLink} target="_blank" rel="noopener noreferrer">open in new window <Icon name="external share" /></a>
              </Message.Content>
            </Message>

            <Message icon info>
              <Icon name="share alternate" color="pink" />
              <Message.Content>
                <Message.Header>Shareable link (Table)</Message.Header>
                {shareableLinkTable}&nbsp;-&nbsp; <a href={shareableLinkTable} target="_blank" rel="noopener noreferrer">open in new window <Icon name="external share" /></a>
              </Message.Content>
            </Message>

            <Message icon info>
              <Icon name="share alternate" color="black" />
              <Message.Content>
                <Message.Header>Shareable link (Instagram & Tiktok)</Message.Header>
                {shareableLinkInstagramTiktok}&nbsp;-&nbsp; <a href={shareableLinkInstagramTiktok} target="_blank" rel="noopener noreferrer">open in new window <Icon name="external share" /></a>
              </Message.Content>
            </Message>

            { wrongShareValues && wrongShareValues.length > 0 && <Message
              error
              header="There was some errors with your submission. Please check the values below:"
              list={wrongShareValues}
            />
            }

            {
              !isVoxogram &&
              <Form>
                <Form.Group widths="equal">
                  <Form.Input
                    label="share with"
                    placeholder="enter comma separated email list..."
                    name="emailList"
                    value={emailList}
                    onChange={this.handleChange}
                  />
                  <Form.Button
                    disabled={!emailList || v.isEmpty(emailList)}
                    label="."
                    color="pink"
                    icon="mail outline"
                    content="share shortlist"
                    onClick={this.handleShare}
                  />
                </Form.Group>
              </Form>
            }

            {
              _.map(history, h => (
                <p>{h.message}</p>
              ))
            }
          </Segment>
          <Divider hidden />
          <ShortlistSummary
            influencerCount={influencerCount}
            totalTwitter={totalTwitter}
            totalInstagram={totalInstagram}
            totalYoutube={totalYoutube}
            totalFacebook={totalFacebook}
            totalTwitch={totalTwitch}
            totalTiktok={totalTiktok}
          />
          <Divider />

          <Header as="h2">
            Influencers
            { compactCards
              ? <Button floated="right"icon="toggle down" basic content="expand all" onClick={this.toggleCardView} style={buttonStyles} />
              : <Button floated="right" icon="toggle up" basic content="collapse all" onClick={this.toggleCardView} style={buttonStyles} />
            }
          </Header>

          <Segment loading={loading} basic style={{ margin: 0, padding: 0 }}>
            { _.map(list, influencer => {
              const linkRecord = _.find(linksMap, { influencerId: influencer.id });
              let description;
              if (linkRecord) {
                const link = _.find(links, { id: linkRecord.linkId });
                description = link.influencerDetails.description;
              }
              return (
                <InfluencerShortlistEditableCard
                  influencer={influencer}
                  organisation={user.organisation}
                  dataNode={dataMap[influencer.id]}
                  description={description}
                  onChange={this.handleNoteChange}
                  onSave={this.handleSave}
                  onRemove={this.handleRemove}
                  compact={compactCards}
                />);
            }) }
          </Segment>

          { isDyzioTeam && <CloneShortlistModal
            loading={cloneModal.isSearching}
            visible={cloneModal.visible}
            selected={cloneModal.selected}
            closeHandler={this.closeCloneShortListModal}
            searchHandler={this.handleCloneShortListModalSearch}
            selectedHandler={this.handleOptionsSelected}
            searched={cloneModal.searched}
            yepButtonHandler={this.handleCloneButton}
            options={cloneModal.options}
          />
          }

          {
            addCampaignModalOpen &&
            <NewAddCampaignModal
              onClose={this.toggleAddCampaignModalState}
              onAddCampaignSubmit={this.onAddCampaignSubmit}
            />
          }
        </div>
      </div>
    );
  }
}

Shortlist.propTypes = {
  userInfo: PropTypes.object.isRequired,
  jsonAPIClient: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.user.user,
});

export default compose(
  hasUserInfo,
  hasJSONAPIClient,
  connect(mapStateToProps),
)(Shortlist);



/** WEBPACK FOOTER **
 ** ./src/containers/shortlist/index.js
 **/